export function Status({value}:{value:string}) {
  const key=value.replaceAll('_',' ')
  const good=['matched','ready to ship','label ready','shipped','delivered','paid','authorized'].some(v=>key.includes(v))
  const warn=['pending','expected','inspection','awaiting','quoted','draft','hold','unknown','exception'].some(v=>key.includes(v))
  return <span className={`status ${good?'status--good':warn?'status--warn':'status--plain'}`}><i/>{key}</span>
}
